import reportSlice from "./pvs_activities/redux/reportSlice";
import stepSlice from "./pvs_activities/pages/stepSlice";
import { templateApi } from "./pvs_activities/redux/service/templates";
import { formsApi } from "./pvs_activities/redux/service/forms";
import { formDataApi } from "./pvs_activities/redux/service/formData";
import { elementsApi } from "./pvs_activities/redux/service/elements";
import { dFormApi } from "./pvs_activities/redux/service/dForm";
import { formCommentsApi } from "./pvs_activities/redux/service/formComments";
import { formAttachmentsApi } from "./pvs_activities/redux/service/formAttachments";
import { listsApi } from "./pvs_activities/redux/service/lists";
import { downloadDocumentApi } from "./pvs_activities/redux/service/downloadForm";
import { missionsApi } from "./pvs_activities/redux/service/missions";
import { movementHistoryApi } from "./pvs_activities/redux/service/movementHistory";
import { missionExpertApi } from "./pvs_activities/redux/service/missionExpert";
import { rolesApi } from "./pvs_activities/redux/service/roles";
import { usersApi } from "./pvs_activities/redux/service/user";
import { formRuleConditionsApi } from "./pvs_activities/redux/service/formRuleConditions";
import { formRuleGroupsApi } from "./pvs_activities/redux/service/formRuleGroups";
import { formRuleActionsApi } from "./pvs_activities/redux/service/formRuleActions";
import { movementApi } from "./pvs_activities/redux/service/movements";
import { missionExpertsApi } from "./pvs_activities/redux/service/missionExperts";
import { commonApi } from "./pvs_activities/redux/service/common";
import { formCCPropertiesApi } from "./pvs_activities/redux/service/formCCProperties";
import { pvsaUserApi } from "./pvs_activities/redux/service/pvsaUser";
import { processApi } from "./pvs_activities/redux/service/processes";
import { countryApi } from "./pvs_activities/redux/service/country";
import { formVariablesApi } from "./pvs_activities/redux/service/formVariables";
import { languageApi } from "./pvs_activities/redux/service/language";
import { expertApi } from "./pvs_activities/redux/service/experts";
import { formSectionsApi } from "./pvs_activities/redux/service/formSections";

const reducers = {
  // register your module's reducers
  // example:
  // test: TestReducer
  report: reportSlice,
  step: stepSlice,
};

export const rtkqReducers = {
  // register your module's redux RTKQ middlewares
  [templateApi.reducerPath]: templateApi.reducer,
  [formsApi.reducerPath]: formsApi.reducer,
  [formDataApi.reducerPath]: formDataApi.reducer,
  [elementsApi.reducerPath]: elementsApi.reducer,
  [dFormApi.reducerPath]: dFormApi.reducer,
  [formCommentsApi.reducerPath]: formCommentsApi.reducer,
  [formAttachmentsApi.reducerPath]: formAttachmentsApi.reducer,
  [listsApi.reducerPath]: listsApi.reducer,
  [downloadDocumentApi.reducerPath]: downloadDocumentApi.reducer,
  [missionsApi.reducerPath]: missionsApi.reducer,
  [movementHistoryApi.reducerPath]: movementHistoryApi.reducer,
  [missionExpertApi.reducerPath]: missionExpertApi.reducer,
  [rolesApi.reducerPath]: rolesApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [formRuleConditionsApi.reducerPath]: formRuleConditionsApi.reducer,
  [formRuleGroupsApi.reducerPath]: formRuleGroupsApi.reducer,
  [formRuleActionsApi.reducerPath]: formRuleActionsApi.reducer,
  [movementApi.reducerPath]: movementApi.reducer,
  [missionExpertsApi.reducerPath]: missionExpertsApi.reducer,
  [commonApi.reducerPath]: commonApi.reducer,
  [formCCPropertiesApi.reducerPath]: formCCPropertiesApi.reducer,
  [pvsaUserApi.reducerPath]: pvsaUserApi.reducer,
  [processApi.reducerPath]: processApi.reducer,
  [formVariablesApi.reducerPath]: formVariablesApi.reducer,
  [countryApi.reducerPath]: countryApi.reducer,
  [languageApi.reducerPath]: languageApi.reducer,
  [expertApi.reducerPath]: expertApi.reducer,
  [formSectionsApi.reducerPath]: formSectionsApi.reducer,
};

export const middlewares = [
  // register your module's redux middlewares
  templateApi.middleware,
  formsApi.middleware,
  formDataApi.middleware,
  elementsApi.middleware,
  dFormApi.middleware,
  countryApi.middleware,
  formCommentsApi.middleware,
  formAttachmentsApi.middleware,
  listsApi.middleware,
  downloadDocumentApi.middleware,
  missionsApi.middleware,
  movementHistoryApi.middleware,
  missionExpertApi.middleware,
  rolesApi.middleware,
  usersApi.middleware,
  formRuleConditionsApi.middleware,
  formRuleGroupsApi.middleware,
  formRuleActionsApi.middleware,
  movementApi.middleware,
  missionExpertsApi.middleware,
  commonApi.middleware,
  formCCPropertiesApi.middleware,
  pvsaUserApi.middleware,
  processApi.middleware,
  formVariablesApi.middleware,
  languageApi.middleware,
  expertApi.middleware,
  formSectionsApi.middleware,
];

export default reducers;
